
// Banner Slider

const bannerSection = document.getElementById("bannerSection");

const swiper = new Swiper(".mySwiper", {
  loop: true,
  effect: "fade",            // <-- Change this to "fade", "cube", "flip", or "creative"
  fadeEffect: { crossFade: true },
  autoplay: {
    delay: 3000,
    disableOnInteraction: false
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true
  },
  on: {
    init: function () {
      // Set initial background color
      const firstSlide = this.slides[this.activeIndex];
      bannerSection.style.backgroundColor = firstSlide.dataset.bgcolor;

      // Set pagination bullets color
      this.slides.forEach((slide, index) => {
        const bullet = this.pagination.bullets[index];
        if (bullet) bullet.style.background = slide.dataset.bgcolor;
      });
    },
    slideChange: function () {
      const currentSlide = this.slides[this.activeIndex];
      bannerSection.style.backgroundColor = currentSlide.dataset.bgcolor;
    }
  }
});



// Best Selling Product

document.addEventListener('DOMContentLoaded', function () {
  const productSwiper = new Swiper('.productSwiper', {
    loop: true,
    autoplay: false, // Disabled autoplay
    pagination: false, // Disabled dots
    navigation: {
      nextEl: '.productSwiper .swiper-button-next',
      prevEl: '.productSwiper .swiper-button-prev'
    },
    slidesPerView: 1.5,
    spaceBetween: 12,
    breakpoints: {
      480: { slidesPerView: 1.5, spaceBetween: 10 },
      768: { slidesPerView: 2, spaceBetween: 10 },
      1024: { slidesPerView: 3, spaceBetween: 10 },
      1400: { slidesPerView: 4, spaceBetween: 12 }
    }
  });
});

// Collection List

document.addEventListener('DOMContentLoaded', function () {
  const swiperContainer = document.querySelector('.custcollcSwiper');
  const slides = swiperContainer.querySelectorAll('.swiper-slide');

  // Duplicate slides to ensure loop works when slides < slidesPerView*2
  const slidesPerViewDesktop = 4;
  if (slides.length < slidesPerViewDesktop * 5) {
    const cloneCount = slidesPerViewDesktop * 5 - slides.length;
    for (let i = 0; i < cloneCount; i++) {
      const clone = slides[i % slides.length].cloneNode(true);
      swiperContainer.querySelector('.swiper-wrapper').appendChild(clone);
    }
  }

  // Initialize Swiper
  const custcollcSwiper = new Swiper('.custcollcSwiper', {
    loop: true,
    slidesPerView: 1.5,
    spaceBetween: 12,
    navigation: {
      nextEl: '.custcollcSwiper .swiper-button-next',
      prevEl: '.custcollcSwiper .swiper-button-prev'
    },
    pagination: false,
    autoplay: false,
    breakpoints: {
      480: { slidesPerView: 1.5, spaceBetween: 10 },
      768: { slidesPerView: 2, spaceBetween: 10 },
      1024: { slidesPerView: 3, spaceBetween: 10 },
      1400: { slidesPerView: 4, spaceBetween: 12 } // desktop: 4 slides
    }
  });
});

// Customer Video

document.addEventListener('DOMContentLoaded', function () {
  const swiperContainer = document.querySelector('.videoSwiper');
  const slides = swiperContainer.querySelectorAll('.swiper-slide');

  // Duplicate slides to ensure loop works when slides < slidesPerView*2
  const slidesPerViewDesktop = 5;
  if (slides.length < slidesPerViewDesktop * 8) {
    const cloneCount = slidesPerViewDesktop * 8 - slides.length;
    for (let i = 0; i < cloneCount; i++) {
      const clone = slides[i % slides.length].cloneNode(true);
      swiperContainer.querySelector('.swiper-wrapper').appendChild(clone);
    }
  }

  // Initialize Swiper
  const videoSwiper = new Swiper('.videoSwiper', {
    loop: true,
    slidesPerView: 1.5,
    spaceBetween: 12,
    navigation: {
      nextEl: '.videoSwiper .swiper-button-next',
      prevEl: '.videoSwiper .swiper-button-prev'
    },
    pagination: false,
    autoplay: false,
    breakpoints: {
      480: { slidesPerView: 1.5, spaceBetween: 10 },
      768: { slidesPerView: 2, spaceBetween: 10 },
      1024: { slidesPerView: 3, spaceBetween: 10 },
      1400: { slidesPerView: 5, spaceBetween: 12 } // desktop: 4 slides
    }
  });
});








